var $6dd2fbaad93b6878$exports = {};
$6dd2fbaad93b6878$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " do ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " izabran");
  },
  "finishRangeSelectionPrompt": "Kliknite da dovr\u0161ite opseg izabranih datuma",
  "maximumDate": "Zadnji raspolo\u017Eivi datum",
  "minimumDate": "Prvi raspolo\u017Eivi datum",
  "next": "Slede\u0107i",
  "previous": "Prethodni",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Izabrani datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Izabrani period: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Kliknite da zapo\u010Dnete opseg izabranih datuma",
  "todayDate": function todayDate(args) {
    return "Danas, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Danas, izabran ".concat(args.date);
  }
};
export { $6dd2fbaad93b6878$exports as default };